import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "edit-file-card" }
const _hoisted_2 = {
  key: 0,
  class: "edit-file-muted"
}
const _hoisted_3 = {
  key: 1,
  class: "edit-file-muted"
}
const _hoisted_4 = {
  key: 2,
  class: "files-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = { class: "file-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 3,
  class: "replace-block"
}
const _hoisted_11 = { class: "replace-hint" }
const _hoisted_12 = { class: "replace-row" }
const _hoisted_13 = {
  key: 0,
  class: "replace-new"
}
const _hoisted_14 = {
  key: 1,
  class: "replace-none"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "replace-actions" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "add-new-files-block",
  style: {"margin-top":"16px","border-top":"1px dashed #e2e8f0","padding-top":"12px"}
}
const _hoisted_19 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_20 = {
  class: "selected-files-list",
  style: {"flex":"1"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "edit-file-muted",
  style: {"font-size":"12px"}
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "popup-header popup-header--files" }
const _hoisted_26 = { class: "popup-header-main" }
const _hoisted_27 = { class: "popup-header-texts" }
const _hoisted_28 = { class: "popup-header-title" }
const _hoisted_29 = { class: "popup-header-meta" }
const _hoisted_30 = { class: "status-chip status-chip--active" }
const _hoisted_31 = { class: "details-container" }
const _hoisted_32 = { class: "info-sections-grid" }
const _hoisted_33 = { class: "info-column" }
const _hoisted_34 = { class: "info-section-card" }
const _hoisted_35 = { class: "info-list" }
const _hoisted_36 = { class: "info-item" }
const _hoisted_37 = { class: "value highlight" }
const _hoisted_38 = { class: "info-item" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "info-item" }
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "info-item" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "info-item" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "info-column" }
const _hoisted_47 = { class: "info-section-card" }
const _hoisted_48 = { class: "info-list" }
const _hoisted_49 = {
  key: 0,
  class: "info-item"
}
const _hoisted_50 = {
  key: 1,
  class: "info-item"
}
const _hoisted_51 = {
  key: 2,
  class: "info-item"
}
const _hoisted_52 = {
  class: "files-list",
  style: {"max-height":"280px","overflow-y":"auto"}
}
const _hoisted_53 = { class: "file-name" }
const _hoisted_54 = { class: "file-actions" }
const _hoisted_55 = {
  ref: "popupBody",
  class: "popup-body-simple popup-body-modern"
}
const _hoisted_56 = { class: "form-content form-content-modern" }
const _hoisted_57 = {
  class: "edit-file-card",
  style: {"margin-top":"16px"}
}
const _hoisted_58 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-top":"8px"} }
const _hoisted_59 = {
  class: "selected-files-list",
  style: {"flex":"1"}
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  key: 1,
  class: "edit-file-muted",
  style: {"font-size":"12px"}
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "form-footer footer-modern" }
const _hoisted_65 = { class: "footer-right" }
const _hoisted_66 = { class: "popup-header popup-header--products" }
const _hoisted_67 = { class: "popup-header-main" }
const _hoisted_68 = { class: "popup-header-texts" }
const _hoisted_69 = { class: "popup-header-title" }
const _hoisted_70 = { class: "details-container" }
const _hoisted_71 = { class: "info-sections-grid" }
const _hoisted_72 = { class: "info-column" }
const _hoisted_73 = { class: "info-section-card" }
const _hoisted_74 = { class: "info-list" }
const _hoisted_75 = { class: "info-item" }
const _hoisted_76 = { class: "value highlight" }
const _hoisted_77 = { class: "info-item" }
const _hoisted_78 = { class: "value" }
const _hoisted_79 = { class: "info-item" }
const _hoisted_80 = { class: "value" }
const _hoisted_81 = { class: "info-column" }
const _hoisted_82 = { class: "info-section-card" }
const _hoisted_83 = { class: "info-list" }
const _hoisted_84 = { class: "info-item" }
const _hoisted_85 = { class: "value highlight" }
const _hoisted_86 = { class: "info-item" }
const _hoisted_87 = { class: "value" }
const _hoisted_88 = { class: "info-item" }
const _hoisted_89 = { class: "value highlight" }
const _hoisted_90 = { class: "info-item" }
const _hoisted_91 = { class: "value" }
const _hoisted_92 = { class: "popup-body-simple" }
const _hoisted_93 = { class: "form-content" }
const _hoisted_94 = { class: "form-footer footer-modern mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_dx_button = _resolveComponent("dx-button")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxFormItemGrid = _resolveComponent("DxFormItemGrid")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxForm = _resolveComponent("DxForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": {
            store: _ctx.dsOferte,
            filter: ['SaleID', '=', _ctx.opportunityId]
        },
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      class: "grid theme-dependent",
      onExporting: _ctx.onExporting,
      onSelectionChanged: _ctx.onSelectionChanged,
      onEditingStart: _ctx.onEditingStart
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxScrolling, { mode: 'virtual' }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxLoadPanel, { "show-pane": false }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Cauta Oferta",
          "search-visible-columns-only": true
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_dx_button, {
                    icon: "plus",
                    type: "success",
                    onClick: _ctx.onAddClick,
                    disabled: _ctx.isLocked || !_ctx.resolvedIsOfertareStatus,
                    hint: !_ctx.resolvedIsOfertareStatus ? 'Adăugarea ofertelor este permisă doar în starea Ofertare' : 'Adaugă Ofertă'
                  }, null, 8, ["onClick", "disabled", "hint"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick,
                    hint: "Reimprospateaza"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              hint: "Exporta"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxTexts, {
          "group-continued-message": "Continuat de pe pagina anterioara",
          "group-continues-message": "Continuat pe pagina urmatoare"
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: !_ctx.isLocked,
          allowDeleting: !_ctx.isLocked,
          mode: "popup",
          onClick: _ctx.onRowRemoving
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 580,
              height: 590
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "before",
                  options: _ctx.reviseButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItemGrid, {
                  "item-type": "group",
                  "col-span": 2,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, { dataField: "Nume" }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Data",
                      "editor-type": "dxDateBox",
                      "editor-options": {
                            type: 'datetime',
                            displayFormat: 'dd/MM/yyyy HH:mm',
                            dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                            useMaskBehavior: true
                        }
                    }),
                    _createVNode(_component_DxFormItemGrid, {
                      "item-type": "simple",
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "edit-file-title" }, "Documente / Fișiere", -1)),
                          _createElementVNode("input", {
                            type: "file",
                            ref: "editOfertaFileInput",
                            style: {"display":"none"},
                            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onReplaceFileSelectedCustom && _ctx.onReplaceFileSelectedCustom(...args)))
                          }, null, 544),
                          _createElementVNode("input", {
                            type: "file",
                            multiple: "",
                            id: "editOfertaInputHidden",
                            style: {"display":"none"},
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEditFileSelectedCustom && _ctx.onEditFileSelectedCustom(...args)))
                          }, null, 32),
                          (_ctx.isEditFilesLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Se încarcă..."))
                            : (_ctx.editOfertaFiles.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nu există fișiere atașate. "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editOfertaFiles, (f) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["file-row", { active: _ctx.selectedEditFile?.ID === f.ID }]),
                                      key: f.ID,
                                      onClick: ($event: any) => (_ctx.selectFileForReplace(f))
                                    }, [
                                      _createElementVNode("div", _hoisted_6, _toDisplayString(f.FileName), 1),
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "dx-button dx-button-mode-text dx-button-normal dx-widget",
                                          title: "Descarcă",
                                          onClick: _withModifiers(($event: any) => (_ctx.onDownloadOfertaFile(f)), ["stop"])
                                        }, [...(_cache[12] || (_cache[12] = [
                                          _createElementVNode("span", { class: "dx-button-content" }, [
                                            _createElementVNode("i", { class: "dx-icon dx-icon-download" })
                                          ], -1)
                                        ]))], 8, _hoisted_8),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "dx-button dx-button-mode-text dx-button-danger dx-widget",
                                          title: "Șterge",
                                          disabled: _ctx.isLocked,
                                          onClick: _withModifiers(($event: any) => (_ctx.onDeleteOfertaFile(f)), ["stop"])
                                        }, [...(_cache[13] || (_cache[13] = [
                                          _createElementVNode("span", { class: "dx-button-content" }, [
                                            _createElementVNode("i", { class: "dx-icon dx-icon-trash" })
                                          ], -1)
                                        ]))], 8, _hoisted_9)
                                      ])
                                    ], 10, _hoisted_5))
                                  }), 128))
                                ])),
                          (_ctx.editOfertaFiles.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _cache[14] || (_cache[14] = _createTextVNode(" Se va înlocui: ", -1)),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.selectedEditFile?.FileName || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  (_ctx.editReplaceFile)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Nou: " + _toDisplayString(_ctx.editReplaceFile.name), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "(Niciun fișier nou selectat)")),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "dx-button dx-button-mode-outlined dx-button-normal dx-widget",
                                    disabled: _ctx.isLocked,
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileSelect && _ctx.triggerFileSelect(...args)))
                                  }, [...(_cache[15] || (_cache[15] = [
                                    _createElementVNode("span", { class: "dx-button-content" }, [
                                      _createElementVNode("i", { class: "dx-icon dx-icon-upload" }),
                                      _createElementVNode("span", { class: "dx-button-text" }, "Alege alt fișier")
                                    ], -1)
                                  ]))], 8, _hoisted_15)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "dx-button dx-button-mode-outlined dx-button-success dx-widget",
                                    disabled: !_ctx.selectedEditFile?.ID || !_ctx.editReplaceFile,
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.replaceCurrentFile && _ctx.replaceCurrentFile(...args)))
                                  }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("span", { class: "dx-button-content" }, [
                                      _createElementVNode("span", { class: "dx-button-text" }, "Înlocuiește")
                                    ], -1)
                                  ]))], 8, _hoisted_17)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", {
                              class: "edit-file-title",
                              style: {"margin-bottom":"8px"}
                            }, "Adaugă fișiere noi ", -1)),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                (_ctx.selectedFilesEdit && _ctx.selectedFilesEdit.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilesEdit, (file, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          style: {"display":"flex","align-items":"center","gap":"6px","font-size":"13px","font-weight":"600","color":"#059669","margin-bottom":"4px"}
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(file.name), 1),
                                          _createElementVNode("span", {
                                            class: "dx-icon-remove",
                                            style: {"cursor":"pointer","color":"#ef4444"},
                                            onClick: ($event: any) => (_ctx.removeEditFile(index)),
                                            title: "Șterge fișier"
                                          }, null, 8, _hoisted_22)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_23, " (Niciun fișier nou selectat) "))
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "dx-button dx-button-mode-outlined dx-button-normal dx-widget",
                                disabled: _ctx.isLocked,
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerEditFileAdd && _ctx.triggerEditFileAdd(...args)))
                              }, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("span", { class: "dx-button-content" }, [
                                  _createElementVNode("i", { class: "dx-icon dx-icon-upload" }),
                                  _createElementVNode("span", { class: "dx-button-text" }, "Alege fișiere")
                                ], -1)
                              ]))], 8, _hoisted_24)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["allowUpdating", "allowDeleting", "onClick"]),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          savingTimeout: 100,
          "storage-key": "gridCardOferteState"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          caption: "Nume Ofertă"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Data",
          caption: "Data"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataModificat",
          "sort-order": "desc",
          visible: false,
          caption: "Data Modificare"
        }),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          buttons: [
                {
                    hint: 'Fișiere',
                    icon: 'floppy',
                    onClick: _ctx.onViewOfertaFiles
                },
                {
                    hint: 'Descarcă Raport',
                    icon: 'print',
                    onClick: _ctx.onDownloadReport
                },
                {
                    hint: 'Produse',
                    icon: 'box',
                    onClick: _ctx.onShowProducts
                },
                {
                    hint: 'Revizie (creează o versiune nouă)',
                    icon: 'copy',
                    onClick: _ctx.onRevise,
                    visible: !_ctx.isLocked
                },
                {
                    name: 'edit',
                    visible: !_ctx.isLocked
                },
                {
                    name: 'delete',
                    visible: !_ctx.isLocked
                }
            ]
        }, null, 8, ["buttons"])
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onSelectionChanged", "onEditingStart"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isOfertaFilesVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isOfertaFilesVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 650,
      height: 500
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "popup-header-icon dx-icon-floppy" }, null, -1)),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.selectedOfertaForFiles?.Nume || 'Ofertă'), 1),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "popup-header-subtitle" }, "Documente și fișiere atașate", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatDate(_ctx.selectedOfertaForFiles?.Data)), 1)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "100%",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-info section-icon" }),
                      _createElementVNode("span", null, "Detalii Ofertă")
                    ], -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", null, "Nume", -1)),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.selectedOfertaForFiles?.Nume || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", null, "Data", -1)),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatDate(_ctx.selectedOfertaForFiles?.Data)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", null, "Oportunitate", -1)),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.selectedOfertaForFiles?.Sale?.Titlu || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "Creat de", -1)),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.selectedOfertaForFiles?.UserCreat || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Modificat de", -1)),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.selectedOfertaForFiles?.UserModificat || '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-floppy section-icon" }),
                      _createElementVNode("span", null, "Documente / Fișiere")
                    ], -1)),
                    _createElementVNode("div", _hoisted_48, [
                      (_ctx.isOfertaViewFilesLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("div", { class: "value" }, "Se încarcă fișierele...", -1)
                          ]))]))
                        : (_ctx.ofertaViewFiles.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[29] || (_cache[29] = [
                              _createElementVNode("div", { class: "value" }, "Nu există fișiere atașate.", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("label", null, "Fișiere (" + _toDisplayString(_ctx.ofertaViewFiles.length) + ")", 1),
                              _createElementVNode("div", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ofertaViewFiles, (f) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "file-row",
                                    key: f.ID
                                  }, [
                                    _createElementVNode("div", _hoisted_53, _toDisplayString(f.FileName), 1),
                                    _createElementVNode("div", _hoisted_54, [
                                      _createVNode(_component_DxButton, {
                                        icon: "download",
                                        "styling-mode": "text",
                                        hint: "Descarcă",
                                        onClick: () => _ctx.onDownloadOfertaFile(f)
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 580,
      height: 450
    }, {
      title: _withCtx(() => [...(_cache[31] || (_cache[31] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare ofertă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_DxForm, { formData: _ctx.formData }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  dataField: "Nume",
                  "editor-options": { width: '100%' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Nume' este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Data",
                  "editor-type": "dxDateBox",
                  "editor-options": {
                            type: 'datetime',
                            displayFormat: 'dd/MM/yyyy',
                            dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                            useMaskBehavior: true
                        }
                })
              ]),
              _: 1
            }, 8, ["formData"]),
            _createElementVNode("input", {
              type: "file",
              multiple: "",
              ref: "addOfertaFileInput",
              style: {"display":"none"},
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAddFileSelected && _ctx.onAddFileSelected(...args)))
            }, null, 544),
            _createElementVNode("div", _hoisted_57, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "edit-file-title" }, "Documente / Fișiere", -1)),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.selectedFilesAdd && _ctx.selectedFilesAdd.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilesAdd, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            style: {"display":"flex","align-items":"center","gap":"6px","font-size":"13px","font-weight":"600","color":"#059669","margin-bottom":"4px"}
                          }, [
                            _createElementVNode("span", null, _toDisplayString(file.name), 1),
                            _createElementVNode("span", {
                              class: "dx-icon-remove",
                              style: {"cursor":"pointer","color":"#ef4444"},
                              onClick: ($event: any) => (_ctx.removeAddFile(index)),
                              title: "Șterge fișier"
                            }, null, 8, _hoisted_61)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_62, " (Niciun fișier selectat) "))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "dx-button dx-button-mode-outlined dx-button-normal dx-widget",
                  disabled: _ctx.isLocked,
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerAddFileSelect && _ctx.triggerAddFileSelect(...args)))
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("span", { class: "dx-button-content" }, [
                    _createElementVNode("i", { class: "dx-icon dx-icon-upload" }),
                    _createElementVNode("span", { class: "dx-button-text" }, "Alege fișiere")
                  ], -1)
                ]))], 8, _hoisted_63)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onSaveAdd,
                disabled: _ctx.isLocked
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isProductsDetailsVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isProductsDetailsVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 750,
      height: 450
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "popup-header-icon dx-icon-product" }, null, -1)),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.selectedProduct.Nume || 'Detalii Ofertă'), 1),
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "popup-header-subtitle" }, "Informații generale despre ofertă", -1))
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--active" }, " Activă ")
          ], -1))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "100%",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-info section-icon" }),
                      _createElementVNode("span", null, "Detalii Ofertă")
                    ], -1)),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Nume Ofertă", -1)),
                        _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.selectedProduct.Nume || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", null, "Data Ofertă", -1)),
                        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.formatDate(_ctx.selectedProduct.Data)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Oportunitate", -1)),
                        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.selectedProduct.Sale?.Titlu || '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-clock section-icon" }),
                      _createElementVNode("span", null, "Istoric")
                    ], -1)),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", null, "Creat de", -1)),
                        _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.selectedProduct.UserCreat || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", null, "Data Creării", -1)),
                        _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.formatDate(_ctx.selectedProduct.DataCreat, true)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _cache[43] || (_cache[43] = _createElementVNode("label", null, "Modificat de", -1)),
                        _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.selectedProduct.UserModificat || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _cache[44] || (_cache[44] = _createElementVNode("label", null, "Data Modificării", -1)),
                        _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.formatDate(_ctx.selectedProduct.DataModificat, true)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isRevisePopupVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isRevisePopupVisible) = $event)),
      closeOnOutsideClick: false,
      showCloseButton: true,
      showTitle: true,
      width: 500,
      height: 320
    }, {
      title: _withCtx(() => [...(_cache[46] || (_cache[46] = [
        _createElementVNode("div", { class: "popup-header popup-header--revise" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-copy" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Salvează ca (Revizuire)"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Introduceți numele pentru noua versiune")
            ])
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createVNode(_component_DxForm, { formData: _ctx.reviseFormData }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  dataField: "Nume",
                  label: { text: 'Nume ofertă nouă' },
                  "editor-options": { width: '100%', placeholder: 'Ex: Ofertă v2' }
                })
              ]),
              _: 1
            }, 8, ["formData"])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: _ctx.onReviseConfirm
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Anulează",
              type: "danger",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: _ctx.onReviseCancel
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}